import studio1 from "@/assets/login/studio-1.png";
import studio2 from "@/assets/login/studio-2.png";
import logo from "@/assets/logo-cineblocks-1.svg";
import { LoginForm } from "@/components/login/login-form";
import googleIcon from "@/assets/login/devicon_google.svg";
import facebookIcon from "@/assets/login/logos_facebook.svg";
import { BtnSocial } from "@/components/login/btn-social";
import { Link } from "wouter";
import { SplitScreen } from "@/components/ui/split-screen";

export default function Login() {
  return (
    <SplitScreen
      firstComponent={
        <div className="h-full flex flex-col items-center justify-center gap-4">
          <img
            src={studio1}
            alt="Estúdio 1"
            className="rounded-2xl object-cover h-full 2xl:h-1/3 w-10/12"
          />
          <img
            src={studio2}
            alt="Estúdio 2"
            className="rounded-2xl object-cover h-full 2xl:h-1/3 w-10/12"
          />
        </div>
      }
      secondComponent={
        <div className="h-full flex flex-col items-center lg:items-start justify-center">
          <div className="max-w-md w-full space-y-3">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2">
                <img src={logo} alt="Logo Cineblocks" className="w-7" />
                <h1 className="text-2xl font-bold">cineblocks</h1>
              </div>
              <p className="text-base mt-1.5">Bem-vindo ao Sistema Cineblocks!</p>
              <p className="text-xs text-label mt-1">
                Entre com sua conta social ou faça login com seus dados
              </p>
            </div>

            {/* Botões Sociais */}
            <div className="flex justify-center gap-compact">
              <BtnSocial icon={googleIcon} alt="Google" />
              <BtnSocial icon={facebookIcon} alt="Facebook" />
            </div>

            {/* Formulário */}
            <LoginForm />

            <p className="text-center text-xs text-label">
              Não tem uma conta?{" "}
              <Link href="/criar-conta" className="text-primary hover:underline">
                Faça seu cadastro
              </Link>
            </p>
          </div>
        </div>
      }
    />
  );
}

